import Common from '../../Common';

interface Search {
	limit?: string | number
	limit_from?: string | number
}

const Invoice = class extends Common {
	browse = (companyId: id, search?: Search): CustomResponseBrowse<{ invoices: Invoice[] }> =>
		this.get(`/company/${companyId}/invoice`, search)

	details = (companyId: id) =>
		this.get(`/company/${companyId}/invoice/details`);

	download = (companyId: id, id: id): CustomResponse<Blob> =>
		this.get(`/company/${companyId}/invoice/${id}/download`, {}, { responseType: 'blob' })
}

export default Invoice;
